import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-saz-viewer',
  templateUrl: './saz-viewer.component.html',
  styleUrls: ['./saz-viewer.component.css']
})
export class SazViewerComponent implements OnInit {
  fileSource: any;
  finalUpdatedUrl: any;

  constructor(
    private sanitizer: DomSanitizer, private alert: ToastrService,
    public dialogRef: MatDialogRef<SazViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


  ngOnInit(): void {
    if (this.data && this.data.url) {
      const domain = `https://thepaidclick.com/sazviewer`;
      const parameterOne = `/?url=${this.data.url}`
      const parameterTwo = this.data && this.data.highlightText ? `&keyword=${this.data.highlightText}` : ``
      const finalUrl = domain + parameterOne + parameterTwo;
      this.finalUpdatedUrl = finalUrl;
      this.fileSource = this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  getHostName(link: string) {
    if (!link)
      return '';
    let url = new URL(link);
    return url.host;
  }

  copyLink() {
    this.alert.success('Link Copied..!!', '')
    let content = this.finalUpdatedUrl;;
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = content;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  download() {
    window.open(this.data.url);
  }
}